import script from "./AgregarComponentesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgregarComponentesView.vue?vue&type=script&lang=ts&setup=true"

import "./AgregarComponentesView.vue?vue&type=style&index=0&id=2d00f430&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d00f430"]])

export default __exports__